export default __webpack_public_path__ + "static/media/sneak-peek-video-thumbnail.60bf7899.png";